import React, { useContext, useState, useEffect, useRef } from "react";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import swal from "sweetalert";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import { GlobalContext } from "../../Context/GlobalState";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";

const pririties = [
  { label: "Select Priority", value: "" },
  { label: "High", value: "1" },
  { label: "Medium", value: "2" },
  { label: "Low", value: "3" },
];

const CreditRequest = () => {
  const initialState = {
    amount: "",
    remark: "",
    priority: { label: "Select Priority", value: "" },
  };

  const [state, setState] = useState(initialState);
  const [formErrors, setFormErrors] = useState({ mobile: "" });
  const { user, setTransactionLoaderState, Profileinfo } =
    useContext(GlobalContext);

  const validateForm = () => {
    const errors = {};
    if (state.amount == "") {
      errors.amount = "*Please enter amount";
    } else if (Number(state.amount) < 100) {
      errors.amount = "*Please enter amount greaterr than 100";
    }
    if (state.priority.value == "") {
      errors.priority = "*Please select priority";
    }
    setFormErrors(errors);
    if (Object.keys(errors).length == 0) {
      submitCreditRequest();
    }
  };

  const clearForm = () => {
    setState(initialState);
  };

  const submitCreditRequest = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        priority: state.priority.value,
        type: "1",
        amount: state.amount,
        remaks: state.remark,
        paySlip: "",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.SUBMIT_CREDIT_REQUEST}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        swal("Success", data.data.message, "success");
        clearForm();
      } else {
        swal("Failed", data.msg, "error");
      }

      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    setState({ ...state, name: Profileinfo?.name });
  }, [Profileinfo]);

  console.log(state);

  return (
    <div style={{ padding: "1rem" }} className="bg-light ">
      <div
        style={{ borderRadius: "10px" }}
        className="card  p-0 m-0 mx-2 mt-4 "
      >
        <div className="card-body m-0 p-3">
          <div>
            <div
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Credit Request
            </div>

            <div>
              <div className="col-10 m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col-6 p-0 pr-2">
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>User Id</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="User ID"
                        value={user.ReferId}
                        disabled
                      />
                    </Form.Group>
                  </div>

                  <div className="col-6 p-0 pl-2 ">
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>User Name</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="User Name"
                        maxLength="10"
                        value={state.name}
                        disabled
                      />
                    </Form.Group>
                  </div>
                </div>
           
           
              </div>

              <div className="col-10 m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col-6 p-0 pr-2 ">
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>Enter Amount</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Amount"
                        value={state.amount}
                        onChange={(e) => {
                          setState({ ...state, amount: e.target.value });
                        }}
                      />
                      <p style={{ color: "red" }}>{formErrors.amount}</p>
                    </Form.Group>
                  </div>

                  <div className="col-6 p-0 pl-2 ">
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>
                          Remark (optional)
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Remarks (optional)"
                        value={state.remark}
                        onChange={(e) => {
                          setState({ ...state, remark: e.target.value });
                        }}
                      />
                      <p style={{ color: "red" }}>{formErrors.remark}</p>
                    </Form.Group>
                  </div>
                  <div className="col-6 p-0 pr-2 ">
                    <Form.Group className="rounded-100">
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}> Select Priority</span>
                      </Form.Label>
                      <Select
                        options={pririties}
                        value={state.priority}
                        onChange={(e) => {
                          setState({ ...state, priority: e });
                        }}
                      />
                      <p style={{ color: "red" }}>{formErrors.priority}</p>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div className="row">
              <div className="col-2 p-0 ml-2">
                <Button
                  className="rounded-50 btn btn-primary btn-lg btn-block"
                  onClick={validateForm}
                >
                  {" "}
                  Submit
                </Button>
              </div>
              <div className="col-2 p-0 ml-2">
                <Button
                  className="rounded-50 btn border-primary btn-lg btn-block bg-white border text-primary"
                  onClick={clearForm}
                >
                  {" "}
                  Clear
                </Button>
              </div>
              <div className="col p-0"></div>
              <div className="col p-0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const EmptyArrayHandler = () => {
  return (
    <div className="row">
      <div className="col-12">
        <span style={{ fontSize: "1.4rem" }}>No records Found</span>
      </div>
    </div>
  );
};
export default CreditRequest;
